import type { ParsedUrlQuery } from 'querystring';

import { useQuery } from '@tanstack/react-query';

import { callService } from '@api/remote-call';
import { ApiRequestOptions } from '@api/core/ApiRequestOptions';
import { ContentsService } from '@api/v3';

export const useDataRating = (id: number) => {
  const { data: ratingDetail } = useQuery(
    ['getRatingDetail', id],
    () =>
      callService(
        {
          service: 'HotelsService',
          method: 'getReviews',
          version: 'v3',
        },
        {
          id: id,
        }
      ),
    {
      enabled: Boolean(id),
    }
  );
  return { ratingDetail };
};
export const useListingBanners = (
  query: ParsedUrlQuery,
  options?: ApiRequestOptions
) => {
  const { slug } = query;

  return ContentsService.getListingBanners(
    {
      slug: String(slug),
    },
    options
  );
};
